import { gql } from "@apollo/client";
import { Def_MutationResponse } from "../../UserCalls/GQLCalls/userCalls";

export const VERIFY_SECTION_CREATE = gql`
  query VerifySectionCreate($domain: String!, $section: [CreateLocation!]!) {
    section {
      verifyCreate(domain: $domain, section: $section){
        success,
        existingTerminals {
          device_id
          location_id
          location_name: name
          terminal_id
          port
          visual
        }
      }
    }
  }
`

export interface VerifySectionCreateResponse {
  section: {
    verifyCreate: VerifySectionCreate
  }
}

interface VerifySectionCreate extends Def_MutationResponse {
  existingTerminals: {
    terminal_id: number;
    device_id: number;
    port: number;
    location_id: number
    location_name: string
    visual: string
  }[]
}